module.exports = __webpack_public_path__ + "static/img/favicon.af6eac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.png
// module id = ZURh
// module chunks = 19